import * as TYPES from './types';

const clearError = () => ({type: TYPES.CLEAR_ERROR});

export default clearError;
